<template>
	<div class="bg-color-greige pt-500-md">
		<div class="container display-flex flex-direction-column-smo pt-500">
			<div class="col-6-md pr-150-md">
				<h1 class="font-weight-bold overline text-color-content-secondary mb-100">{{ data.heading }}</h1>
				<h3 class="heading-1">{{ data.title }}</h3>
				<RichTextComponent
					v-if="data.description"
					:blocks="data.description"
					:is-dark-mode="false"
					class="mt-100"
				/>

				<BaseCtaLink
					class="display-block mt-100"
					:link="{ href: data.linkUrl, target: '_blank', text: data.linkText }"
					icon="arrow"
				/>
			</div>
			<div class="col-6-md pl-150-md pt-300-smo">
				<h3 v-if="data.tableHeading" class="heading-5 text-align-center">{{ data.tableHeading }}</h3>
				<AnnualReturnsTableSnapshotView />
			</div>
		</div>
	</div>
</template>
s
<script setup lang="ts">
import AnnualReturnsTableSnapshotView from '@charts/annual-returns-table-snapshot-view.vue';
import RichTextComponent from '@components/sanity/rich-text-component.vue';
import { WhyFundriseAnnualReturnsData } from 'types/sanity/why-fundrise';

interface Props {
	data: WhyFundriseAnnualReturnsData;
}

defineProps<Props>();
</script>
